import { useState, useEffect, useRef } from 'react';
import '../App.css';
import '../Tabs.css';
import AutocompletePaginado from './AutocompletePaginado';
import 'rsuite/DatePicker/styles/index.css';
import { aplicarMascaraCpfCnpj } from '../utils/MaskUtils';
import { request } from '../utils/ApiUtils';
import Input from './Input';
import { showNotification } from '../utils/NotificationUtils';
import InputMonetary from './InputMonetary';
import Table from './Table';
import { formatToBRL } from '../utils/MonetaryUtils';
import SaveIcon from '@mui/icons-material/CheckCircle';
import { hasAnyRole } from '../utils/TokenUtils';
import { rolesMapping } from '../utils/RolesUtils';


function ContratoParcelaFechadorTab(props) {
    const [dataArray, setDataArray] = useState([]);

    const [pageData, setPageData] = useState([]);
    const [carregando, setCarregando] = useState(true); // Estado para exibir um indicador de carregamento
    const [erro, setErro] = useState(null); // Estado para lidar com 

    const carregarDados = async (page = 0, isRefresh) => {
        if (props.contratoId)
            request(`contrato-parcela-fechador/${props.contratoId}/paginated?page=${page}`, {
                type: 'POST',
                body: JSON.stringify({}),
                callback: (data) => (
                    setPageData(data),
                    setDataArray(data.content),
                    props.findTotals(isRefresh)
                ),
                callbackError: (message) => setErro(message || 'Ocorreu um erro inesperado, tente novamente ou contate o suporte.'),
                finally: () => setCarregando(false)
            })
    };

    useEffect(() => {carregarDados();}, [props.contratoId]);

    useEffect(() => {carregarDados(0, true); }, [props.refreshKey]);

    const atualizarParcela = async (parcela) => {
        request(`contrato-parcela-fechador/${parcela.id}`, {
            type: 'PUT',
            body: JSON.stringify(parcela),
            callback: (data) => {
                showNotification('Parcela atualizada', 'success');
                props.findTotals && props.findTotals();
                props.loadContrato && props.loadContrato();
                parcela.alterada = false;
                updateRowOnDataArray(parcela)

            },
            callbackError: (responseData, message) => {
                const errorsEmpty = !responseData?.errors || Object.keys(responseData?.errors).length === 0;

                if (responseData?.handledError) {
                    if (!errorsEmpty) {
                        Object.entries(responseData?.errors).forEach(([key, value]) => {

                            showNotification(value, 'error', 5000);
                        });
                    } else

                        if (responseData?.error) {
                            showNotification(responseData.error, 'error', 5000);
                        }
                } else {
                    showNotification('Não foi possível atualizar a parcela, revise os dados informados.', 'error');
                }
            }
        })
    }

    const onChangeParcela = (parcela, value, field) => {
        const updatedItem = { ...parcela, alterada: true };
        updatedItem[field] = value;

        updateRowOnDataArray(updatedItem)
    }

    const updateRowOnDataArray = (parcela) => {
        const updatedArray = dataArray.map((row) =>
            row.numero === parcela?.numero ? parcela : row
        );

        setDataArray(updatedArray);
    }

    const footerTotals = () => (
        <div className="table-footer-totals">
            <p><span className="table-footer-indicator table-footer-indicator-received" />{`Valor total recebido: ${formatToBRL(props.comissoes?.comissaoFechadorRecebida)}`} <span/></p>
            <h4><span className="table-footer-indicator table-footer-indicator-pending" />{`Valor total a receber: ${formatToBRL(props.comissoes?.comissaoFechadorAReceber)}`}</h4>
        </div>
    )

    const tableParams = {
        query: (page) => carregarDados(page),
        hasFooter: true,
        columns: [
            {
                label: "Nº Parcela",
                width: "15%",
                type: "input",
                disable: true,
                key: "numero"
            },
            {
                label: "Valor Parcela",
                width: "30%",
                disabled: true,
                type: "input-decimal",
                css: "decimal",
                key: "valor"
            },
            {
                label: "Data Vencimento",
                width: "30%",
                widthValue: '45%',
                type: "date",
                disabled: (parcela) => props?.contratoCancelado || parcela?.status?.statusFinalOk || !hasAnyRole(rolesMapping.admin),
                onChange: (parcela, value) => onChangeParcela(parcela, value, 'dataVencimento'),
                key: "dataVencimento"
            },
            {
                label: "Status",
                width: "20%",
                type: "autocomplete",
                htmlFooter: () => footerTotals(),
                        footer: { startColumn: 3, colSpan: 2 },

                // key: "status.status",
                component: {
                    endpoint: "contratos/status",
                    parameters: {
                        disabled: props?.contratoCancelado,
                        disableClearable: true,
                        width: '100%',
                        bodyToSearch: { statusParcela: true },
                        getLabel: (contrato) => contrato.status || '',
                        // onChange: (parcela, statusSelecionado) => onChangeStatus(parcela, statusSelecionado),
                        onChange: (parcela, statusSelecionado) => onChangeParcela(parcela, statusSelecionado?.item, 'status'),
                        getValue: (contrato) => contrato.status,
                        inputStyle: (status) => (
                            {
                                color: 'black',
                                // fontWeight: 'bold',
                                backgroundImage: `radial-gradient(circle, ${status?.item?.color || 'black'} 45%, transparent 50%)`,
                                backgroundPosition: '8px center',
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: '14px 14px',
                                paddingLeft: '28px'
                            }
                        ),
                        POST: true,
                        reload: !!carregando
                    },
                }
            },
            {
                label: "Salvar",
                width: "5%",
                type: "button-icon",
                css: "button",
                icon: (<SaveIcon />),
                color: (parcela) => parcela.alterada ? 'orange' : 'green',
                onClick: (parcela) => atualizarParcela(parcela)
            }
        ]
    };

    return (
        <div className="form-container">

            {/* <NotificationContainer params={notification}/> */}

            <div id="notification-container" className='notification-container' style={{
                position: "fixed",
                display: "flex,",
                flexDirection: "column-reverse",
                justifyContent: "flex-end",
                flexWrap: "wrap-reverse",
                alignItems: "flex-end",
                bottom: "0,",
                right: "30px",
                maxHeight: "100vh"
            }}></div>
            {/* <div className='row'> */}

            {/* <h1 style={{ color: '#5E5E5E' }}>Contrato</h1> */}

            <div className='row'>

                <Input id="numero"
                    value={props.contrato?.numero}
                    parameters={{ width: '12%', label: "Nº do Contrato*", disabled: true }} />

                <AutocompletePaginado label={"Cliente*"}

                    parameters={{
                        label: "Cliente*",
                        width: '30%',
                        disabled: true,
                        getLabel: ((item) => (item.nome + (item.documento ? ` - ${aplicarMascaraCpfCnpj(item.documento)}` : ''))),
                        value: props.contrato?.cliente,
                        title: (props.contrato?.cliente ? `Documento: ${props.contrato?.cliente.documento} 
                                                        \nTelefone: ${props.contrato?.cliente.telefone || ''} 
                                                        \nE-mail: ${props.contrato?.cliente.email || ''}
                                                        \nEndereço: ${props.contrato?.cliente?.endereco?.cidade} - ${props.contrato?.cliente?.endereco?.uf}`
                            : '')
                    }}
                    endpoint={"clientes/paginated"} />

                <InputMonetary id="honorarioInicial"
                    value={props.contrato?.honorarioInicial}
                    disabled={true}
                    width='15%' label="Honorarios Iniciais" />

                <InputMonetary id="comissaoFechador"
                    value={props.comissoes?.comissaoFechador}
                    disabled={true}
                    width='15%' label="Comissão fechador" />

                <AutocompletePaginado label={"Fechador"}
                    parameters={{
                        label: "Fechador*",
                        width: '33%',
                        disabled: true,
                        getLabel: ((item) => item.nome),
                        value: props.contrato?.fechador
                    }}
                    endpoint={"colaboradores/paginated"} />
            </div>

            <Table params={tableParams} dataArray={dataArray} pageData={pageData} />
        </div>
    );
}

export default ContratoParcelaFechadorTab;
